export default __webpack_public_path__ + "static/media/img-0469-bulgaria-full-face.3f950b3a.png";